import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'FEED/DRAFTS';

export const {action: reset} = createAction(`${domain}/RESET`, () => ({}));

export const {action: showDraftSelector} = createAction(`${domain}/SHOW_DRAFT_SELECTOR`, show => ({show}));

export const {action: showObservationForm} = createAction(`${domain}/SHOW_OBSERVATION_FORM`, show => ({show}));

export const {
    action: selectDraft,
    success: selectDraftSuccess,
    failed: selectDraftFailed,
} = createAction(
    `${domain}/SELECT_DRAFT`,
    (form, draft, draftIsDirty, canUseRichTextInPosts) => ({form, draft, draftIsDirty, canUseRichTextInPosts}),
    (draftId, showObservationForm, variant) => ({draftId, showObservationForm, variant}),
);

export const {
    action: update,
    success: updateSuccess,
    failed: updateFailed,
} = createAction(
    `${domain}/UPDATE`,
    (
        draftId,
        recipients,
        from,
        body,
        richTextBody,
        files,
        observationData,
        disableFeedback,
        activities,
        famlyLiveMeetingId,
    ) => ({
        draftId,
        recipients,
        from,
        body,
        richTextBody,
        files,
        observationData,
        disableFeedback,
        send: false,
        activities,
        famlyLiveMeetingId,
    }),
    (oldDraftId, newDraft) => ({oldDraftId, newDraft}),
    draft => ({draft}),
    draft => ({draft}),
);

export const {
    action: updatePost,
    success: updatePostSuccess,
    failed: updatePostFailed,
} = createAction(
    `${domain}/UPDATE_POST`,
    (
        postId,
        body,
        richTextBody,
        formIdentifier,
        recipients,
        from,
        files,
        observationData,
        disableFeedback,
        reNotify,
        activities,
        famlyLiveMeetingId,
    ) => ({
        postId,
        body,
        richTextBody,
        formIdentifier,
        recipients,
        from,
        files,
        observationData,
        disableFeedback,
        reNotify,
        activities,
        famlyLiveMeetingId,
    }),
);

export const {
    action: send,
    success: sendSuccess,
    failed: sendFailed,
    aborted: sendAborted,
} = createAction(
    `${domain}/SEND`,
    (
        draftId,
        recipients,
        from,
        body,
        richTextBody,
        files,
        formIdentifier,
        observationData,
        disableFeedback,
        activities,
        famlyLiveMeetingId,
        facebookPageIds,
        rssInstitutionSetIds,
        overridePostBlock,
        sendAsSms,
    ) => ({
        draftId,
        recipients,
        from,
        body,
        richTextBody,
        files,
        formIdentifier,
        observationData,
        disableFeedback,
        send: true,
        activities,
        famlyLiveMeetingId,
        facebookPageIds,
        rssInstitutionSetIds,
        overridePostBlock,
        sendAsSms,
    }),
    (draftId, famlyLiveMeetingId) => ({draftId, famlyLiveMeetingId}),
    draftId => ({draftId}),
    draftId => ({draftId}),
);

export const {
    action: clearDraft,
    success: clearDraftSuccess,
    failed: clearDraftFailed,
} = createAction(`${domain}/CLEAR_DRAFT`, (showObservationForm, form, draftIsDirty) => ({
    showObservationForm,
    form,
    draftIsDirty,
}));

export const {action: newPostFormDidChange} = createAction(`${domain}/NEW_POST_FORM_DID_CHANGE`, formName => ({
    formName,
}));

export const {action: createOrUpdate, failed: createOrUpdateFailed} = createAction(
    `${domain}/CREATE_OR_UPDATE`,
    formName => ({formName}),
);

export const {action: closeDraftManagerModal} = createAction(`${domain}/CLOSE_DRAFT_MANAGER_MODAL`, () => ({}));
